// 9fbef606107a605d69c0edbcd8029e5d 
export const maxAllowedStoresInCart = 2;
export const minStoreCount = 1;
export const distancesMap = [
  {
    id: '25',
    displayName: '25 miles',
  },
  {
    id: '50',
    displayName: '50 miles',
  },
  {
    id: '75',
    displayName: '75 miles',
  },
];

export default {
  minStoreCount,
  maxAllowedStoresInCart,
  distancesMap,
};
